module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.detailsProduct,
      "onClick": _vm.onSelect,
      "withBody": _vm.isDisplayDetails,
      "withFooter": _vm.isDisplayDetails,
      "to": _vm.to
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [(_vm.isDisplayList) ? _c('span', {
    staticClass: "badge hint hint--left",
    class: _vm.productStatus,
    attrs: {
      "data-label": _vm.getLastSyncMessage(_vm.product.date)
    }
  }, [_vm._v(_vm._s(("" + (_vm.$tc('variations.count.label', _vm.product.variations.length, { count: _vm.product.variations.length })))))]) : _vm._e(), _vm._v(" "), (_vm.canSynchronize()) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "title": "Sincronizar produto"
    },
    on: {
      "click": _vm.syncProduct
    }
  }, [_c('i', {
    staticClass: "icon-sync icon-loop2"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "variation l-col-1@md"
  }, [(_vm.image) ? _c('img', {
    attrs: {
      "src": _vm.image
    }
  }) : _c('i', {
    staticClass: "icon icon-image2 no-photo"
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "l-col-5@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-5@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('brand.label')))]), _vm._v("\n            " + _vm._s(_vm._f("attribute")(_vm.product.brand)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-7@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('status.label')))]), _vm._v(" "), _c('span', {
    staticClass: "badge status hint hint--top",
    class: _vm.productStatus,
    attrs: {
      "data-label": _vm.getLastSyncMessage(_vm.product.date)
    }
  }, [_vm._v(_vm._s(_vm.$t((_vm.productStatus + ".label"))))])])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-5@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('createdAt.label')))]), _vm._v("\n            " + _vm._s(_vm._f("attribute")(_vm._f("moment")(_vm.product.createdAt, 'DD/MM/YYYY HH:mm'))) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-7@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('productGroupedId.label')))]), _vm._v("\n            " + _vm._s(_vm._f("attribute")(_vm.product.productId)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-5@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('manufacturerReference.label')))]), _vm._v("\n            " + _vm._s(_vm._f("attribute")(_vm.manufacturerReference)) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-8@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.product.variations.length === 1 ? 'Variação' : 'Variações'))]), _vm._v(" "), (_vm.product.variations.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.product.variations[0].sku))]) : _c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.showVariationModalFlag = true
      }
    }
  }, [_vm._v("Ver todas")]), _vm._v(" "), _c('variation-modal', {
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.showVariationModalFlag),
      callback: function($$v) {
        _vm.showVariationModalFlag = $$v
      },
      expression: "showVariationModalFlag"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('stock.label')))]), _vm._v("\n            " + _vm._s(_vm._f("attribute")(_vm.quantity)) + "\n          ")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "l-col-3@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('span', {
    staticClass: "oldPrice"
  }, [_vm._v("De " + _vm._s(_vm._f("currency")(_vm.oldPrice)) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('span', {
    staticClass: "newPrice"
  }, [_vm._v("Por " + _vm._s(_vm._f("currency")(_vm.price)) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "marketplaces",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, _vm._l((_vm.definitionMarketplacesInstalled), function(definitionModule) {
    return _c('img', {
      class: _vm.getImgClass(definitionModule),
      attrs: {
        "src": definitionModule.icon,
        "alt": definitionModule.name
      }
    })
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ef27fde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductProvide/List/Card/Shared.vue
// module id = 3211
// module chunks = 0